import * as React from "react";
import { makeStyles } from "@fluentui/react-components";

import { AccountBar } from "../../components/AccountBar";
import { SignInGate } from "../../components/SignInGate";
import { TicketForm } from "../../components/TicketForm";
import { clearSession, loadSession, saveSession, type Session } from "../../lib/session";

const useStyles = makeStyles({
  root: { display: "flex", flexDirection: "column", gap: "12px", padding: "12px 16px 24px" },
});

/**
 * The whole task pane: either the sign-in gate or the ticket form.
 *
 * Note what this component does *not* do — wait for Office. It renders from
 * localStorage immediately, and the parts that need a message prefill
 * themselves once Office is ready. Gating the render on Office.onReady would
 * make the pane a blank rectangle in a plain browser, which is exactly where
 * the sign-in and ticket flow are easiest to test.
 */
const App: React.FC = () => {
  const styles = useStyles();
  const [session, setSession] = React.useState<Session | null>(() => loadSession());

  const signIn = React.useCallback((next: Session) => {
    saveSession(next);
    setSession(next);
  }, []);

  const signOut = React.useCallback(() => {
    clearSession();
    setSession(null);
  }, []);

  return (
    <div className={styles.root}>
      {session ? (
        <>
          <AccountBar session={session} onSignOut={signOut} />
          {/* Keyed by token so a re-sign-in starts the form from scratch
              rather than reusing state fetched with the old session. */}
          <TicketForm key={session.token} token={session.token} onSessionExpired={signOut} />
        </>
      ) : (
        <SignInGate onSignedIn={signIn} />
      )}
    </div>
  );
};

export default App;
